<template>
  <user-table></user-table>
</template>

<script>
import UserTable from '../components/tables/UserTable.vue'

export default {
  name: 'UserAdmin',
  components: {
    UserTable
  }
}
</script>

<style scoped></style>
